/** Focus can remain after iOS's Done button dismisses the keyboard. Ignore the
 * smaller residual viewport inset in that state, and ignore pinch zoom. */
export function hasKeyboardViewport(
  editing: boolean,
  fullHeight: number,
  visibleHeight: number,
  scale: number,
): boolean {
  return editing && scale === 1 && fullHeight - visibleHeight > 120;
}
